import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Login',
      component: () => import('@/views/auth/Login'),
    },
    {
      path: '/',
      component: () => import('@/views/dashboard/Index'),
      meta: {
        requiresAuth: true,
      },
      children: [
        // Organizations
        {
          name: 'Organizations',
          path: '/organizations',
          component: () => import('@/views/dashboard/organizations/OrganizationList'),
        },
        {
          name: 'Create Organization',
          path: '/organizations/create',
          component: () => import('@/views/dashboard/organizations/CreateOrganization'),
        },
        {
          name: 'Organization Details Landing Page',
          path: '/organizations/:organizationId',
          component: () => import('@/views/dashboard/organizations/OrganizationDetailsLandingPage'),
        },
        {
          name: 'Edit Organization Details',
          path: '/organizations/edit/:organizationId',
          component: () => import('@/views/dashboard/organizations/EditOrganization'),
        },
        // Users
        {
          name: 'Users',
          path: '/users',
          component: () => import('@/views/dashboard/users/Users'),
        },
        {
          name: 'Create User',
          path: '/users/create',
          component: () => import('@/views/dashboard/users/CreateUser'),
        },
         // DigiBoards
         {
          name: 'DigiBoards',
          path: '/digi-boards',
          component: () => import('@/views/dashboard/digiboards/DigiBoardsList'),
        },
        {
          name: 'Create DigiBoards',
          path: '/digi-boards/create',
          component: () => import('@/views/dashboard/digiboards/CreateDigiBoards'),
        },
        {
          name: 'DigiBoard Contents',
          path: '/digi-boards/:id',
          component: () => import('@/views/dashboard/digiboards/EditDigiBoardContent'),
        },
        // support
        {
          name: 'Support Tickets',
          path: '/support',
          component: () => import('@/views/dashboard/support/SupportLandingPage'),
        },
        {
          name: 'Support Ticket Chats',
          path: '/support/app-modules/:appModuleName/tickets/:ticketId/chats',
          component: () => import('@/views/dashboard/support/SupportTicketChats'),
        },
        // Account Control
        {
          name: 'Settings',
          path: '/settings',
          component: () => import('@/views/dashboard/settings/Settings'),
        },
        // Payments
        {
          name: 'Payments',
          path: '/payments',
          component: () => import('@/views/dashboard/payments/Payments'),
        },
        {
          name: 'Products',
          path: '/products/:productid',
          component: () => import('@/views/dashboard/payments/Prices'),
        },
        {
          name: 'Widgets',
          path: '/widgets',
          component: () => import('@/views/dashboard/widgets/Widgets'),
        },
        {
          name: 'App Modules',
          path: '/app-modules',
          component: () => import('@/views/dashboard/appmodules/AppModulesList'),
        },
        // Partners
        {
          name: 'Partners',
          path: '/partners',
          component: () => import('@/views/dashboard/partners/PartnersList'),
        },
        {
          name: 'Partners',
          path: '/partners/:id/api',
          component: () => import('@/views/dashboard/partners/PartnerAPIsList'),
        },
        // Digital Marketing
        {
          name: 'Digital Markeing',
          path: '/digital-marketing',
          component: () => import('@/views/dashboard/digitalmarketing/DigitalMarketingLanding'),
        },
        //Blogs
        {
          name: 'KnowledgeBase',
          path: '/knowledgebase',
          component: () => import('@/views/dashboard/knowledgebase/KnowBaseList.vue'),
        },
        {
          name: 'CreateKnowledgeBase',
          path: '/createknowledgebase',
          component: () => import('@/views/dashboard/knowledgebase/createKnowledgeBase.vue'),
        },
        {
          name: 'UpdateKnowledgeBase',
          path: '/updateknowledgebase/:slug',
          component: () => import('@/views/dashboard/knowledgebase/updateKnowledgeBase.vue'),
        },
        // Blogs
        {
          name: 'Blogs',
          path: '/blogs',
          component: () => import('@/views/dashboard/blogs/Blogs'),
        },
        {
          name: 'Create Blog',
          path: '/blogs/create',
          component: () => import('@/views/dashboard/blogs/CreateBlog'),
        },
        {
          name: 'Edit Blog',
          path: '/blogs/:id',
          component: () => import('@/views/dashboard/blogs/EditBlog'),
        },

        //Blogs
        {
          name: 'KnowledgeBase',
          path: '/knowledgebase',
          component: () => import('@/views/dashboard/knowledgebase/KnowBaseList.vue'),
        },
        {
          name: 'CreateKnowledgeBase',
          path: '/createknowledgebase',
          component: () => import('@/views/dashboard/knowledgebase/createKnowledgeBase.vue'),
        },
        {
          name: 'UpdateKnowledgeBase',
          path: '/updateknowledgebase/:slug',
          component: () => import('@/views/dashboard/knowledgebase/updateKnowledgeBase.vue'),
        }
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem('user');

  if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn) {
    next('/');
    return;
  }

  next();
});

export default router;
